/** Normalize API date strings to `YYYY-MM-DD` for `<input type="date" />`. */
export function toDateInputValue(value: string | undefined | null): string {
  if (!value) return '';
  const m = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : '';
}
